export default __webpack_public_path__ + "static/media/local_grocery_storeshopping_cart.51c5d552.svg";